export const environment = {
    production: true,
    KeycloakConfig: {
        url: 'https://cerbere.mipih.fr/auth/',
        realm: 'Medimail_TEST',
        clientId: 'medimail_patient_web',
        clientSecret: ''
    },
    appName: 'Medimail Patient Preprod',
    appNameAcronym: 'MML Patient Preprod',
    appUrl : 'https://medimailpatienttest.mipih.fr',
    appApiUrl: 'https://api.medimailpatienttest.mipih.fr/api/',
    appBackUrl : 'https://api.medimailpatienttest.mipih.fr',
    locales : ['en','fr']
};
